module.exports = __webpack_public_path__ + "img/chart-help-1.3781fb4.svg";